module.exports = __webpack_public_path__ + "img/fan03.1f2628e1.png";